import { RobotRead } from 'api/schema'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { PATH } from 'utils/constants'

import style from './RobotList.module.css'

const RobotModalItem = ({
  robot,
  selected,
  onSelect,
}: {
  robot: RobotRead
  selected: boolean
  onSelect: () => void
}) => {
  const { t } = useTranslation()

  return (
    <div className={selected ? clsx(style.tableItem, style.selected) : style.tableItem} onClick={onSelect}>
      <span className={style.robotName}>{robot.serial_number}</span>
      <span className={style.robotName}>{robot.name} </span>
      <a className={style.link} href={`${PATH.ROBOT}${robot.id}`} target="_blank" rel="noreferrer">
        {t('common.show')}
      </a>
    </div>
  )
}

const RobotsList = ({
  robots,
  selectedRobot,
  onSelect,
  onScrollBottom,
}: {
  robots: RobotRead[]
  selectedRobot: RobotRead | undefined
  onSelect: (robot: RobotRead) => void
  onScrollBottom: () => void
}) => {
  const { t } = useTranslation()

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const target = e.currentTarget
    if (target.scrollHeight - target.scrollTop <= target.clientHeight + 1) {
      onScrollBottom()
    }
  }

  return (
    <>
      <div className={style.tableHeader}>
        <span className={style.robotName}>{'Serial number'}</span>
        <span className={style.robotName}>{'Name'}</span>
        <span>{'Link'}</span>
      </div>
      <div className={style.table} onScroll={handleScroll}>
        {robots.map(robot => (
          <RobotModalItem
            key={robot.id}
            robot={robot}
            selected={robot === selectedRobot}
            onSelect={() => onSelect(robot)}
          />
        ))}
      </div>
    </>
  )
}

export default RobotsList
